import { FC } from "react";
import { LoadToTrailerModal } from "./LoadToTrailerModal";
import { LoadToTrailerErrorModal, LoadToTrailerErrorModalProps } from "./LoadToTrailerErrorModal";
import { MiddleMilePartnerSelectionModal } from "./MiddleMilePartnerSelectionModal";

export const loadToTrailerModalMap: Record<LoadToTrailerModal, FC<any>> = {
  [LoadToTrailerModal.INVALID_BOL_ID]: LoadToTrailerErrorModal,
  [LoadToTrailerModal.GAYLORD_NOT_FOUND]: LoadToTrailerErrorModal,
  [LoadToTrailerModal.TRAILER_ID_INPUT_MATCHES_GAYLORD_ID_FORMAT]: LoadToTrailerErrorModal,
  [LoadToTrailerModal.TRAILER_ID_INPUT_MATCHES_BOL_ID_FORMAT]: LoadToTrailerErrorModal,
  [LoadToTrailerModal.GAYLORD_STATUS_NOT_ALLOWED_FOR_TRAILER_SCAN]: LoadToTrailerErrorModal,
  [LoadToTrailerModal.ZONE_SKIP_GAYLORD_TRAILER_SCAN_AT_DESTINATION]: LoadToTrailerErrorModal,
  [LoadToTrailerModal.GAYLORD_TRANSFER_NOT_COMPLETE]: LoadToTrailerErrorModal,
  [LoadToTrailerModal.INVALID_BOL]: LoadToTrailerErrorModal,
  [LoadToTrailerModal.INVALID_GAYLORD_ID]: LoadToTrailerErrorModal,
  [LoadToTrailerModal.MIDDLE_MILE_PARTNER_SELECTION]: MiddleMilePartnerSelectionModal,
  [LoadToTrailerModal.MISSING_MAIL_ID_FOR_AIR_SHIPMENT]: LoadToTrailerErrorModal,
  [LoadToTrailerModal.QUINCE_NON_QUINCE_BOL_MISMATCH]: LoadToTrailerErrorModal,
  [LoadToTrailerModal.QUINCE_GAYLORD_TYPE_BOL_MISMATCH]: LoadToTrailerErrorModal,
  [LoadToTrailerModal.INVALID_QUINCE_AIR_TRIP_ID_FORMAT]: LoadToTrailerErrorModal,
  [LoadToTrailerModal.UNKNOWN_ERROR]: LoadToTrailerErrorModal,
};

export const loadToTrailerMessageMap: Record<LoadToTrailerModal, LoadToTrailerErrorModalProps> = {
  [LoadToTrailerModal.INVALID_BOL_ID]: {
    title: "Invalid BOL ID",
    text: "This BOL ID is unrecognized. Scan again or try another barcode.",
    hideModalValue: LoadToTrailerModal.INVALID_BOL_ID,
  },
  [LoadToTrailerModal.INVALID_BOL]: {
    title: "Invalid BOL",
    text: "Existing BOL in the system is invalid. Please contact a supervisor",
    hideModalValue: LoadToTrailerModal.INVALID_BOL_ID,
  },
  [LoadToTrailerModal.INVALID_GAYLORD_ID]: {
    title: "Invalid GAYLORD ID",
    text: "This Gaylord ID is unrecognized. Scan again or try another barcode.",
    hideModalValue: LoadToTrailerModal.INVALID_GAYLORD_ID,
  },
  [LoadToTrailerModal.TRAILER_ID_INPUT_MATCHES_GAYLORD_ID_FORMAT]: {
    title: "Trailer ID value cannot be a Gaylord ID",
    text: "Value matches Gaylord ID format. Please input the truck/trailer ID.",
    hideModalValue: LoadToTrailerModal.TRAILER_ID_INPUT_MATCHES_GAYLORD_ID_FORMAT,
  },
  [LoadToTrailerModal.TRAILER_ID_INPUT_MATCHES_BOL_ID_FORMAT]: {
    title: "Trailer ID value cannot be a BOL ID",
    text: "Value matches BOL ID format. Please input the truck/trailer ID.",
    hideModalValue: LoadToTrailerModal.TRAILER_ID_INPUT_MATCHES_BOL_ID_FORMAT,
  },
  [LoadToTrailerModal.GAYLORD_NOT_FOUND]: {
    title: "Invalid gaylord",
    text: "The gaylord scanned is not valid. Try again or scan a different gaylord.",
    hideModalValue: LoadToTrailerModal.GAYLORD_NOT_FOUND,
  },
  [LoadToTrailerModal.GAYLORD_STATUS_NOT_ALLOWED_FOR_TRAILER_SCAN]: {
    title: "Gaylord status not allowed for trailer scan",
    text:
      "The gaylord scanned is in a state that is not permitted for BOL/Trailer scan. Try again or scan a different gaylord.",
    hideModalValue: LoadToTrailerModal.GAYLORD_STATUS_NOT_ALLOWED_FOR_TRAILER_SCAN,
  },
  [LoadToTrailerModal.ZONE_SKIP_GAYLORD_TRAILER_SCAN_AT_DESTINATION]: {
    title: "Zone skip gaylord cannot be loaded",
    text: "Zone skip gaylord must be re-sorted at destination. Cannot load to trailer.",
    hideModalValue: LoadToTrailerModal.ZONE_SKIP_GAYLORD_TRAILER_SCAN_AT_DESTINATION,
  },
  [LoadToTrailerModal.GAYLORD_TRANSFER_NOT_COMPLETE]: {
    title: "Gaylord transfer not complete",
    text:
      "This gaylord's transfer has not been completed. Please complete the transfer scan first before loading to trailer.",
    hideModalValue: LoadToTrailerModal.GAYLORD_TRANSFER_NOT_COMPLETE,
  },
  [LoadToTrailerModal.UNKNOWN_ERROR]: {
    title: "Unknown error",
    text: "An unknown error occurred. Please try again. Contact a supervisor if the issue persists.",
    hideModalValue: LoadToTrailerModal.UNKNOWN_ERROR,
  },
  [LoadToTrailerModal.MIDDLE_MILE_PARTNER_SELECTION]: {
    title: "",
    text: "",
    hideModalValue: LoadToTrailerModal.MIDDLE_MILE_PARTNER_SELECTION,
  },
  [LoadToTrailerModal.MISSING_MAIL_ID_FOR_AIR_SHIPMENT]: {
    title: "Mail ID missing on Quince pallet",
    text: "The mail ID is missing. Please contact a supervisor.",
    hideModalValue: LoadToTrailerModal.MISSING_MAIL_ID_FOR_AIR_SHIPMENT,
  },
  [LoadToTrailerModal.QUINCE_NON_QUINCE_BOL_MISMATCH]: {
    title: "BOL mismatch: Quince and non-Quince",
    text: "Quince and non-Quince gaylords cannot be mixed on the same BOL.",
    hideModalValue: LoadToTrailerModal.QUINCE_NON_QUINCE_BOL_MISMATCH,
  },
  [LoadToTrailerModal.QUINCE_GAYLORD_TYPE_BOL_MISMATCH]: {
    title: "BOL mismatch: Quince air and ground",
    text: "Air and ground Quince gaylords cannot be mixed on the same BOL.",
    hideModalValue: LoadToTrailerModal.QUINCE_GAYLORD_TYPE_BOL_MISMATCH,
  },
  [LoadToTrailerModal.INVALID_QUINCE_AIR_TRIP_ID_FORMAT]: {
    title: "Invalid AWB number",
    text: "Format must be XXX-12345678 (3 characters, dash, 8 characters). Please re-enter.",
    hideModalValue: LoadToTrailerModal.INVALID_QUINCE_AIR_TRIP_ID_FORMAT,
  },
};
